import { Checkbox, TableCell, useTheme } from "@mui/material";
import { CheckboxProps } from "../PermissionProps";
import { useState } from "react";

const CellCheckBox = (props: CheckboxProps) => {
  const { disable, id, onHandleChange, permission } = props;
  const theme = useTheme();
  const defaultValue = disable ? false : permission ? permission[id] : false;
  const [enabled, setEnable] = useState<boolean>(defaultValue);
  const handleChange = (input: React.ChangeEvent<HTMLInputElement>) => {
    setEnable(input.target.checked);
    onHandleChange({ [id]: input.target.checked });
  };
  return (
    <TableCell>
      <Checkbox
        disabled={disable}
        onChange={handleChange}
        checked={enabled}
        size="small"
        sx={{
          color: theme?.color?.secondary,
          "&.Mui-checked": {
            color: theme?.color?.secondary,
          },
          // "&.Mui-disabled":{
          //   color: theme?.color?.greyBackground,
          // }
        }}
      />
    </TableCell>
  );
};
export default CellCheckBox;
